/** @format */

import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import ScrollSmoother from "gsap/ScrollSmoother";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

export default function ScrollToTop() {
	const { pathname } = useLocation();

	useEffect(() => {
		// Deliberately does NOT kill ScrollTriggers.
		//
		// This effect used to open with
		// `ScrollTrigger.getAll().forEach((t) => t.kill())`, which runs on the
		// *initial* mount as well as on navigation and destroys every trigger in
		// the app — including the ones the page's own components registered
		// moments earlier, which they never re-create. The result was that
		// scroll-driven animation silently did nothing anywhere:
		// ScrollTrigger.getAll() returned a single trigger on the landing page,
		// belonging to the one component that happened to mount afterwards.
		//
		// Components register their triggers inside a gsap.context and revert it
		// on unmount, so a route change already disposes of the outgoing page's
		// triggers. All this needs to do is jump to the top and let ScrollTrigger
		// recompute positions for the new layout.
		const smoother = ScrollSmoother.get();
		if (smoother) {
			smoother.scrollTo(0, false);
		} else {
			// Fallback: use window.scrollTo if ScrollSmoother is not available
			window.scrollTo(0, 0);
			document.documentElement.scrollTop = 0;
			document.body.scrollTop = 0;
		}

		// Recompute start/end positions once the new route has laid out.
		const refreshId = setTimeout(() => ScrollTrigger.refresh(), 50);
		return () => clearTimeout(refreshId);
	}, [pathname]);

	return null;
}
